module.exports = __webpack_public_path__ + "static/fullycharged-24db35e01fef4ecc582069bd53429163.png";